import { faFileAlt, faPenAlt, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { useAuthState } from "../../../../MainComponents/GlobalContext";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import VideoCard from "../../../../MainComponents/VideoCard";
import { Loader } from "../../../../MainComponents";

const AdminPastPaper = ({ type }) => {
  const AuthState = useAuthState();
  const [reFetch, setReFetch] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialMaterialType = searchParams.get("material") || "pdfs";
  const [activeMaterialType, setActiveMaterialType] =
    useState(initialMaterialType);

  //!---- get all Matrials -------
  const api = `${process.env.REACT_APP_GET_ALL_PAST_MATRIALS_API}/${type}`;

  const [GetMatrialsSuccess, GetMatrialsErrors, GetMatrialsLoading] = useAxios(
    api,
    "GET",
    type,
    reFetch || type,
  );

  const filteredData = GetMatrialsSuccess?.data;
  const visibleMaterials = filteredData?.filter(
    (item) => item?.type === activeMaterialType,
  );

  const handleMaterialChange = (nextType) => {
    setActiveMaterialType(nextType);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("material", nextType);
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <section className="h-auto w-full overflow-y-auto px-20 py-20 dark:bg-dark dark:text-light sm:px-10">
      <HelmetTags
        title={`${
          type === "est"
            ? "EST Materials"
            : type === "act"
              ? "ACT Materails"
              : type === "dsat"
                ? "DSAT Materials"
                : "Homeschooling Admission"
        } | Nash Academy`}
      ></HelmetTags>

      <div className="mb-20 flex flex-col items-start gap-20">
        <h2 class="w-full text-4xl font-bold md:text-center">
          {type === "est"
            ? "EST Materials"
            : type === "act"
              ? "ACT Materails"
              : type === "dsat"
                ? "DSAT Materials"
                : "Homeschooling Admission"}
        </h2>

        <div className="top-btns flex w-full justify-start gap-5 asm:flex-col asm:items-center ">
          <div className="w-1/2 md:w-full">
            <div
              className={` service-card  md:w-full shadow-xl cursor-pointer snap-start shrink-0 py-8 px-6 flex flex-col items-start gap-3 transition-all duration-300 group ${
                activeMaterialType === "pdfs"
                  ? "bg-secondary text-white"
                  : "bg-white hover:bg-secondary hover:text-white"
              }`}
              onClick={() => handleMaterialChange("pdfs")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleMaterialChange("pdfs");
                }
              }}
            >
              <FontAwesomeIcon icon={faFileAlt} />

              <p
                className={`font-bold text-3xl group-hover:text-white ${
                  activeMaterialType === "pdfs" ? "text-white" : "text-secondary"
                }`}
              >
                Pdfs
              </p>
            </div>
          </div>

          <div className="w-1/2 md:w-full">
            <div
              className={` service-card  md:w-full shadow-xl cursor-pointer snap-start shrink-0 py-8 px-6 flex flex-col items-start gap-3 transition-all duration-300 group ${
                activeMaterialType === "exam"
                  ? "bg-secondary text-white"
                  : "bg-white hover:bg-secondary hover:text-white"
              }`}
              onClick={() => handleMaterialChange("exam")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleMaterialChange("exam");
                }
              }}
            >
              <FontAwesomeIcon icon={faPenAlt} />

              <p
                className={`font-bold text-3xl group-hover:text-white ${
                  activeMaterialType === "exam" ? "text-white" : "text-secondary"
                }`}
              >
                Exams
              </p>
            </div>
          </div>
        </div>

        <div className="top-btns flex w-full justify-start gap-10 asm:flex-col asm:items-center asm:justify-start asm:gap-14">
          {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
            AuthState.userData?.admin?.permissions?.some((permission) =>
              permission.name.startsWith(""),
            )) &&
            activeMaterialType === "pdfs" && (
            <Link
              to={`add-pdf`}
              className="ml-4 rounded-xl border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 "
            >
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              Add Pdf
            </Link>
          )}
          {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
            AuthState.userData?.admin?.permissions?.some((permission) =>
              permission.name.startsWith(""),
            )) &&
            activeMaterialType === "exam" && (
            <Link
              to={`add-exam`}
              className="ml-4 rounded-xl border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 "
            >
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              Add Exam
            </Link>
          )}
        </div>

        <div className="videos video-grid-auto-fit w-full ">
          {GetMatrialsLoading ? (
            <Loader />
          ) : visibleMaterials?.length === 0 ? (
            <p>There is no Materails</p>
          ) : (
            visibleMaterials?.map((video) => (
              <VideoCard
                reFetch={reFetch}
                setReFetch={setReFetch}
                admin
                video={video}
                type={type}
                key={video.key}
                past
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default AdminPastPaper;
